import { render, staticRenderFns } from "./SimulationDetailFileTransfert.vue?vue&type=template&id=4c64da05"
import script from "./SimulationDetailFileTransfert.vue?vue&type=script&lang=ts"
export * from "./SimulationDetailFileTransfert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports